<template>
<div>
    <div
        class="modal trader-info acc-rej"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        
      >
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Order accept or reject</h5>
               <div class="float-right">
                    <button type="button" @click="getbids()" class="btn btn-sm">
                        <span class="fas fa-sync-alt" aria-hidden="true"></span> Refresh
                    </button>
                    <button type="button" class="close"  @click="closePopup()">
                        <span aria-hidden="true">&times;</span>
                    </button>
               </div>
              
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                        <div v-if="loader" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort"
                                     >Cusip</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >QTY</th>  
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >ECN</th> 
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >PRICE</th>  
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >IDC PRICE</th>
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >VALID UNTIL</th>  
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >FIRM UNTIL</th>
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >SETTLEMENT DATE</th>   
                                    <th 
                                    scope="col" 
                                    class=" text-center"
                                    >Trader</th>            
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Action</th>                     
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="bidList.length == 0 && !loader">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in bidList" :key="data.id">
                                <td class="text-wrap"><span class="cusips">{{data.cusip}}</span></td>
                                <td class="text-center">{{data.orderQty}}</td>
                                <td class="text-center">
                                    {{data.ecn}}
                                </td>
                                <td class="text-center">{{data.bidPrice}}</td>
                                <td class="text-center">{{data.idcPrice}}</td>
                                <td class="text-center">{{data.bidBy ? moment.utc(data.bidBy).local().format("hh:mm:ss a") : 'N/A'}}</td>
                                <td class="text-center">{{data.firmUntill ? moment.utc(data.firmUntill).local().format("hh:mm:ss a") : 'N/A'}}</td>
                                <td class="text-center">{{data.settleDate ? moment(data.settleDate).format("MM/DD/YYYY"): 'N/A'}}</td>
                                <td class="text-center">{{data.traderFirstName}} {{data.traderLastName }}<br>
                                    <span v-if="data.isAway" class="text-danger">AWAY</span>
                                </td>
                                <td class="text-center">
                                    <button v-if="data.status != 'SUCCESS' && data.status != 'ACCEPTED'" type="button" @click="setBidAction('accept',data)" class="btn btn-success">Accept</button>
                                    <button v-if="data.status != 'SUCCESS' && data.status != 'ACCEPTED'" type="button" @click="setBidAction('reject',data)" class="btn btn-danger">Reject</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getbids(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
            </div>
          </div>
        </div>
    </div>
</div>      
</template>
<script>
import authService from "@/authService";
import config from "@/config";
export default {
    name: 'OfferAcceptPopUp',
    data() {
        return {
            cognitoSub : null,
            bidList:[],
            loader : false,
            holdings : [],
            retryCounter : 0,
            currentPage: 1,
            perPage: 25,
            searchValue : "",
            totalRows : 0,
            sortColumn: "id",
            sortOrder: "DESC",
            ecn:"",
            broadcastChannel : null

        };
    },
    methods : {
        closePopup(){
            this.broadcastChannel.postMessage({ message: 'close' });
            this.$emit('close');
        },  
        setBidAction(action,bid){
            var message ="Are you sure you want to "+action+" the order?";
            this.$confirm(message,"","question").then(() => {
                this.loader = true;
                const auth = {
                    headers: {'org-token' : authService.getOrgToken() }
                };
                this.$http
                .put(
                    config.baseUrlAutoBidder + '/autobidder/trade',
                        {
                        "id": bid.id+"",
                        "status": action == 'accept' ? "ACCEPTED" : "REJECTED"
                        },
                    auth
                )
                .then(() => {
                    this.loader = false;
                    // get index of object with id
                    var removeIndex = this.bidList.map(function(item) { return item.id; }).indexOf(bid.id);
                    this.bidList.splice(removeIndex, 1);
                    if(this.bidList.length == 0){
                        this.closePopup();
                    }
                    this.broadcastChannel.postMessage({ message: 'action' });

                })
                .catch(() => {
                    this.loader = false;
                });
            });
        
    },
    getbids(){
        this.loader = true;
        this.retryCounter = this.retryCounter+1;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        //let statusValue = this.status.length == 0 ? statusValue = ["BID_SENDING","BID_SENT","ORDER_RECEIVED","ACCEPTED","REJECTED","SUCCESS","HISTORY"] : this.status;
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=ORDER_RECEIVED"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&ecn="+
            this.ecn+
            "&loggedUser="+
            authService.getUser().id+
            "&cognitoSub="+
            authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
        if(result.data.content.length === 0 && this.retryCounter < 3){
            setTimeout(() => { 
                this.getbids(); 
                return false;
            },1000)
            
        } 
          this.totalRows = result.data.pageInfo.totalElements;
          this.bidList = result.data.content;
          this.loader = false;
        }).catch(() => this.loader = false);
    },
    handleMessage(event) {
      // Handle incoming messages from other tabs
      if(event.data.message === "close"){
        this.$emit('close');
      }
      if(event.data.message === "action"){
        this.getbids();
      }
    },
  },
  created(){ 
    this.cognitoSub = authService.getUser().cognitoSub;
    this.getbids();
  },
  mounted(){
    this.$root.$on("orderrefresh", () => {
        console.log("Refreshing list....");
        this.retryCounter = 0;
        this.getbids();
    });
    this.broadcastChannel = new BroadcastChannel('order-autobid');
    this.broadcastChannel.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    this.$root.$off("orderrefresh");
    this.broadcastChannel.close();

  }
};
</script>